import { entity } from 'simpler-state'

export const menu = entity({
    isLoading: false,
    menuData: []
})
export const useMenu = () => menu.use();
export const setLoading = (_isLoading) => menu.set(value => ({ ...value, isLoading: _isLoading }))
export const setMenuData = (_menuData) => menu.set(value => ({ ...value, menuData: _menuData, isLoading: false }))